import {
  AddCircle,
  CloudUpload,
  RemoveCircle,
  ReplayOutlined,
} from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { useState } from "react";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import { addDoc, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import saved from "../../assets/sound/saved.wav";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
const PoCart = (props) => {
  const { cartItems, onAdd, onRemove, data } = props;
  const [finalTotal, setFinalTotal] = useState(0);
  const [vendorName, setVendorName] = useState("");
  const [shipping, setShipping] = useState(0);
  const [formulax, setFormulax] = useState(0);
  var countFinalTotal = 0;

  const current = new Date();
  const day = `${current.getDate()}`;
  const month = `${current.getMonth() + 1}`;
  const year = `${current.getFullYear()}`;
  const m = month < 10 ? "0" + month : month;
  const d = day < 10 ? "0" + day : day;
  const date1 = year + "-" + m + "-" + d;
  const poRef = collection(db, "po");
  // const total = cartItems.reduce(
  //   (acc, c) => acc + Number(c[2] + 1) * Number(c[3]),
  //   0
  // );
  // console.log(total)
  const columns = [
    {
      name: "0", // 0
      label: "id",
      // options: {
      //   display: false,
      // },
    },
    {
      name: "1", // 1
      label: "Title",
    },
    {
      name: "2", // 2
      label: "Cost",
    },
    {
      name: "qty", // 3
      label: "qt",
    },
    {
      name: "-",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const rowId = tableMeta.rowData;
          return (
            <>
              <IconButton
                variant="contained"
                color="primary"
                onClick={(event) => {
                  onAdd(rowId);
                }}
              >
                <AddCircle />
              </IconButton>
              <IconButton
                variant="contained"
                color="error"
                onClick={(event) => {
                  onRemove(rowId);
                }}
              >
                <RemoveCircle />
              </IconButton>
            </>
          );
        },
      },
    },
  ];

  const options = {
    selectableRowsHideCheckboxes: true,
    sortOrder: {
      name: "title",
      direction: "asc",
    },
  };

  const handleUpdateData = () => {
    for (let i = 0; i < cartItems.length; i++) {
      var docId = cartItems[i][0];
      var quantity = Number(cartItems[i].qty);
      var title = cartItems[i][1];
      var cost = Number(cartItems[i][2]);
      createPo(vendorName, date1, docId, title, cost, quantity, shipping);
      updateProducts(docId, quantity);
    }
  };

  const handleCheckData = () => {
    for (let i = 0; i < cartItems.length; i++) {
      var qty = Number(cartItems[i].qty);
      var cost = Number(cartItems[i][2]);
      countFinalTotal = countFinalTotal + cost * qty;
    }
    setFinalTotal(countFinalTotal);
    const setF =
      (Number(shipping) + Number(countFinalTotal)) / Number(countFinalTotal);
    setFormulax(setF);
  };

  const createPo = async (
    vendorName,
    date,
    docId,
    title,
    cost,
    quantity,
    shipping
  ) => {
    await addDoc(poRef, {
      vendorName: vendorName,
      date: date,
      itemId: docId,
      title: title,
      cost: cost,
      quantity: quantity,
      shipping: shipping,
    });
    new Audio(saved).play();
  };

  const updateProducts = async (id, qty) => {
    const userDoc = doc(db, "products", id);
    const exist = data.find((x) => x.id === id);
    exist ? console.log("existe") : console.log("no");
    var store = Number(exist.stock_store);
    var van = Number(exist.stock_van);
    var web = Number(exist.stock_var1);
    var amazon = Number(exist.stock_var2);
    var cost = Number(exist.cost);
    var totto = store + van + amazon + web + qty;
    var newFields = {};

    newFields = {
      stock_store: Number(store) + Number(qty),
      stock_all: totto,
      cost: cost,
    };
    await updateDoc(userDoc, newFields);

    setFinalTotal(countFinalTotal);
    new Audio(saved).play();
  };

  return (
    <div>
      <Grid>
        <Paper>
          {cartItems.length === 0 && (
            <div>
              <Typography>.</Typography>
              <ProductionQuantityLimitsIcon
                sx={{
                  color: "gray",
                  width: 35,
                  height: 35,
                }}
              />
            </div>
          )}
          {cartItems.length !== 0 && (
            <MUIDataTable
              title="Cart"
              columns={columns}
              options={options}
              data={cartItems}
            />
          )}
        </Paper>
      </Grid>
      <Box>
        <Paper elevation={3} sx={{ paddingTop: "25px", gap: 2 }}>
          <Typography variant="caption">Purcahase Order info</Typography>
        </Paper>
        <Paper elevation={3} sx={{ paddingTop: "25px", gap: 2 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              <TextField
                type="text"
                variant="standard"
                color="primary"
                value={vendorName}
                label="Vendor Name"
                autoComplete="off"
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                  setVendorName(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                type="text"
                color="primary"
                variant="standard"
                label="Shipping Cost"
                value={shipping}
                autoComplete="off"
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                  setShipping(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </Paper>
      </Box>
      {cartItems.length !== 0 && (
        <Paper elevation={3} sx={{ paddingTop: "25px", gap: 2 }}>
          <div className="row">
            <div className="col-1 text-right">
              {finalTotal === 0 ? (
                ""
              ) : (
                <>
                  <Box sx={{ backgroundColor: "yellow" }}>
                    <Typography variant="caption">
                      items: {cartItems.length} | Formula :{" "}
                      {formulax.toFixed(4)} | SubTotal : $
                      {finalTotal.toFixed(2)} | Total Po $
                      {(finalTotal + Number(shipping)).toFixed(2)}
                    </Typography>
                  </Box>
                  <Box>
                    <IconButton
                      color="primary"
                      onClick={() => setFinalTotal(0)}
                      aria-label="Reload"
                    >
                      <ReplayOutlined sx={{ width: "40px", height: "40px" }} />
                    </IconButton>
                    <IconButton
                      color="secondary"
                      onClick={handleUpdateData}
                      aria-label="Save to Firestore"
                    >
                      <CloudUpload sx={{ width: "40px", height: "40px" }} />
                    </IconButton>
                  </Box>
                </>
              )}
            </div>
          </div>

          {finalTotal !== 0 ? (
            ""
          ) : (
            <Box>
              <IconButton
                color="warning"
                onClick={handleCheckData}
                aria-label="Check Po"
              >
                <FlipCameraAndroidIcon sx={{ width: "40px", height: "40px" }} />
              </IconButton>
            </Box>
          )}
        </Paper>
      )}
    </div>
  );
};

export default PoCart;
